"use client";

import { useEffect, useState } from "react";

type NavButtonProps = {
  isDarkMode?: boolean;
  children: React.ReactNode;
};

//------------
// モードデザイン
//------------
const LIGHT_BUTTON = "bg-PRIMARY/0 text-BLACK_1 rounded-sm hover:bg-PRIMARY/20";
const DARK_BUTTON = "bg-PRIMARY/0 text-WHITE_1 hover:bg-WHITE_1/20 rounded-sm border-transparent";

/**
 * ナビバー向けデザインモード切替Button
 */
export default function NavButton({ children, isDarkMode }: NavButtonProps) {
  const [classNameButton, setClassNameButton] = useState(LIGHT_BUTTON);

  /**
   * モード切替検出
   */
  useEffect(() => {
    //------------
    // モードを切り替え
    //------------
    if (isDarkMode) {
      setClassNameButton(DARK_BUTTON);
    } else {
      setClassNameButton(LIGHT_BUTTON);
    }
  }, [isDarkMode]);

  return (
    <p
      className={`inline-flex items-center px-1 py-2 text-sm transition-colors duration-200 ease-in-out md:px-3 ${classNameButton}`}
    >
      {children}
    </p>
  );
}
